import { render } from "./Total_Collections_View.vue?vue&type=template&id=50fe402d&scoped=true"
import script from "./Total_Collections_View.vue?vue&type=script&lang=js"
export * from "./Total_Collections_View.vue?vue&type=script&lang=js"

import "./Total_Collections_View.vue?vue&type=style&index=0&id=50fe402d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50fe402d"]])

export default __exports__